export default {
  props:{
    journeyresponse:{required:true, type:Object},
    value:{required:true},
    visible:{type:Boolean,default:true}
  },
  computed: {
    questionresponse(){
      return this.journeyresponse.questionresponse;
    },
    journeyanswers(){
      const temp=this.journeyresponse.journeyanswers;
      temp.sort((a,b)=>(a.field.fieldorder || 0) - (b.field.fieldorder || 0) );
      return temp;
    },
    responseoptions(){
      if(!this.questionresponse){
        return null;
      }
      const opts = this.questionresponse.options;
      opts.sort((a,b)=>{
        return (a.optionorder||0) - (b.optionorder||0);
      });
      return opts;
    },
    journeyanswer(){
      return this.journeyanswers[0];
    },
    field(){
      return this.journeyanswer.field;
    },
    singleValue(){
      if(!this.value){
        return null;
      }
      return this.value.answers[this.journeyanswer.journeyanswerid].value;
    },
    fieldOptions(){
      const temp=this.field.options;
      temp.sort((a,b)=>{
        return (a.optionorder||0) - (b.optionorder||0);
      });
      return temp;
    },
  },
  methods:{
    emitInput(value){
      this.$emit('input',value);
    },
    emitSingleValue(value){
      const result=JSON.parse(JSON.stringify(this.value));
      result.answers[this.journeyanswer.journeyanswerid].value=value;
      this.emitInput(result);
    }
  }
}